module.exports = __webpack_public_path__ + "27da08fa92ffae62f40e87d591055c30.png";